export enum WAITLIST_EVENT_TYPE {
	UPDATE_POSITION = 'UPDATE_POSITION',
	CALL_WAITLIST = 'CALL_WAITLIST',
	UPDATE_WAITLIST = 'UPDATE_WAITLIST',
	UPDATE_HISTORY_WAITLIST = 'UPDATE_HISTORY_WAITLIST',
	DELAY_WAITLIST = 'DELAY_WAITLIST',
}
